"use strict";
import { config, anteriores } from "./../config";
import axios from 'axios';

export const insService = {
    getCategories,
    getInscripcion,
    generateInscripcion,
    deleteInscripcion,
    appendInscripcion,
    generateInscripcionInfantil,
    deleteInscripcionInfantil,
    appendInscripcionInfantil,
    getInscritosByRace,
    getInscritosSinEquipo,
    getTpv,
    setPagador,
    getStatus
}

async function getCategories(carrera) {
    const requestOptions = {
        method: 'GET',
        mode: 'cors'
    }
    //eslint-disable-next-line
    //console.log(process.env)
    //debugger

    const rawResponse = await fetch(`${config.api_url}/categoria/${carrera}`, requestOptions)
        //eslint-disable-next-line
        .catch( error => console.log(error) )
    const content = await rawResponse.json()
    const data = await content
    return data.categorias
}

async function getInscripcion (dni) {
    const data = anteriores.inscritos.find( (t) => t.dni.toUpperCase() === dni.toUpperCase() )
    /*const data = {
        nombre: 'Juan',
        apellidos: 'Nadie',
        fnac: '1998-12-13',
        dni,
        localidad: 'Zaragoza',
        sexo: 'V',
        email: 'soporte@prames.com',
        tlfno: '123456789',
        socio: 'NO',
        nombre_tutor: '',
        dni_tutor: '',
        tlfno_tutor: '',
        categoria: '2',
        marca: '30\' - 35\'',
        apodo: 'TEST',

        club: 'PRAMES',
        camiseta: 'SI',
        talla: 'L',
        ducha: 'NO',
        observaciones: ''
    }*/
    return data
}

async function generateInscripcion (data) {

    const res = await axios.post(`${config.api_url}/inscripcion`, JSON.stringify(data),{
        headers: {
            "Content-Type": "application/json",
            "cache-control": "no-cache"
        }
    })
    const rdo = res.data
    //eslint-disable-next-line

    return rdo
}

async function deleteInscripcion (data) {
    //eslint-disable-next-line
    //console.log(data)
    const res = await axios.delete(`${config.api_url}/inscripcion/quitar/${data}`, {
        headers: {
            "Content-Type": "application/json",
            "cache-control": "no-cache"
        }
    })

    const rdo = res.data
    //eslint-disable-next-line
    //console.log(rdo)
    return rdo
}

async function appendInscripcion (data) {

    const res = await axios.post(`${config.api_url}/inscripcion/agregar`, JSON.stringify(data),{
        headers: {
            "Content-Type": "application/json",
            "cache-control": "no-cache"
        }
    })
    const rdo = res.data
    //eslint-disable-next-line

    return rdo
}

async function getInscritosByRace(carrera) {
    const res = await axios.get(`${config.api_url}/inscripcion/listado/${carrera}`)
    return res.data
}

async function getInscritosSinEquipo(carrera) {
    const res = await axios.get(`${config.api_url}/inscripcion/sinequipo/${carrera}`)
    return res.data
}

async function generateInscripcionInfantil (data) {
    const res = await axios.post(`${config.api_url}/inscripcion/infantil`, JSON.stringify(data),{
        headers: {
            "Content-Type": "application/json",
            "cache-control": "no-cache"
        }
    })
    const rdo = res.data
    //eslint-disable-next-line
    return rdo
}

async function deleteInscripcionInfantil (data) {
    const res = await axios.delete(`${config.api_url}/inscripcion/quitar/infantil/${data}`, {
        headers: {
            "Content-Type": "application/json",
            "cache-control": "no-cache"
        }
    })

    const rdo = res.data
    return rdo
}

async function appendInscripcionInfantil (data) {

    const res = await axios.post(`${config.api_url}/inscripcion/agregar/infantil`, JSON.stringify(data),{
        headers: {
            "Content-Type": "application/json",
            "cache-control": "no-cache"
        }
    })
    const rdo = res.data
    //eslint-disable-next-line

    return rdo
}

async function getTpv(referencia) {
    const res = await axios.get(`${config.api_url}/inscripcion/tpv/${referencia}`)
    return res.data
}

async function setPagador(paga) {
    const res = await axios.post(`${config.api_url}/inscripcion/paga`, JSON.stringify(paga),{
        headers: {
            "Content-Type": "application/json",
            "cache-control": "no-cache"
        }
    })
    const rdo = res.data
    //eslint-disable-next-line

    return rdo
}

async function getStatus() {
    const requestOptions = {
        method: 'GET',
        mode: 'cors'
    }

    const rawResponse = await fetch(`${config.api_url}/`, requestOptions)
        //eslint-disable-next-line
        .catch( error => console.log(error) )
    const content = await rawResponse.json()
    const data = await content
    return data
}

